<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @reset="$gjReset"
            @query="$gjNoticeQuery">
          <gj-warehouse-select
              v-model="filter.warehouseIds"
              placeholder="仓库"
              multiple
          ></gj-warehouse-select>
          <gj-select
              v-model="filter.state"
              :options="WarehouseEum.stateOption"
              placeholder="状态"
          ></gj-select>
          <gj-select
              v-model="filter.type"
              :options="WarehouseEum.typeOption"
              placeholder="类型"
          ></gj-select>
          <gj-country-select
              v-model="filter.country"
              placeholder="国家"
              includeCN
          ></gj-country-select>
          <gj-date-picker
              v-model="filter.date"
              tooltip="创建时间"
              type="daterange"
          ></gj-date-picker>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button
            v-if="$permission('warehouse:add')"
            type="primary"
            @click="add">
          添加
        </gj-button>
        <gj-button
            v-if="$permission('warehouse:delete')"
            :disabled="noSelect || selectedSomeIs('type', WarehouseEum.type.FBA)"
            @click="deleteItem(selectedRows)">
          删除
        </gj-button>
      </template>
      <template #tool-group>
        <gj-tool-group
            help
            log @viewLog="viewLog"
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            name="warehouseInfo"
            :selection="selection"
            :selectable="eqSelectable('type', WarehouseEum.type.SELF)"
            :data="tableData"
            :columns="columns"
            :default-sort = "{prop: 'createTime', order: 'descending'}"
            :pagination="pagination"
            :loading="loading"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">

          <template v-slot:state="{row}">
            <gj-tag type="text" style="margin-right: 10px" shape="rectangle"
                    :color="row.state | optionColor(WarehouseEum.stateOption)">
              {{ row.state | optionText(WarehouseEum.stateOption) }}
            </gj-tag>
          </template>

          <template v-slot:op="{row}">
            <gj-button-group
                type="dropdown-op"
                :config="opBtnConfig(row)"
            ></gj-button-group>
          </template>
        </gj-table>
      </template>
      <template v-if="userGuideState"  #base-content>
        <new-user-guide ref="newUserGuide" :hideNowStep="hideNowStep" ></new-user-guide>
      </template>
    </app-base-main>
</template>

<script>
  import {queryMixin, responseMixin, selectionMixin, userGuideMixin} from "../../../../minxins";
  import {
    deleteWarehouse,
    getWarehouseInfoPage,
    updateWarehouseInfo,
    updateWarehouseStatus
  } from "../../../../api/warehouse";
  import {defaultVal, isMeaningful, isMeaningless} from "../../../../utils/common";
  import {convertToDate} from "../../../../utils/date.util";
  import GjLogModal from "../../../../components/modal/gj-log-modal";
  import {WarehouseEum} from "../enum";
  import {
    WAREHOUSE_GET_ACTIVE_FBA_WAREHOUSE_TREE,
    WAREHOUSE_GET_ACTIVE_SELF_WAREHOUSE_TREE,
    WAREHOUSE_GET_ACTIVE_WAREHOUSE_TREE, WAREHOUSE_GET_FBA_WAREHOUSE_TREE, WAREHOUSE_GET_SELF_WAREHOUSE_TREE,
    WAREHOUSE_GET_WAREHOUSE_TREE
  } from "../../../../store/action-types";
  import AppOpWarehouseModal from "./modal/op/op-warehouse-modal";
  import {OpEnum} from "../../../../utils/options";
  import NewUserGuide from "./components/new-user-guide"

  export default {
    name: "app-warehouse-information",
    mixins: [queryMixin, selectionMixin, responseMixin, userGuideMixin],
    components: { NewUserGuide },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'name', header: '仓库名称', field: 'name', minWidth: '140px'},
          {id: 'type', header: '类型', field: 'option:type', minWidth: '100px', sortable: true, options: WarehouseEum.typeOption},
          {id: 'countryCode', header: '国家', field: 'countryCode', minWidth: '70px', sortable: true},
          {id: 'state', header: '状态', field: 'slot:state', minWidth: '100px', sortable: true, options: WarehouseEum.stateOption},
          {id: 'contact', header: '负责人', field: 'contact', minWidth: '100px'},
          {id: 'telephone', header: '联系电话', field: 'telephone', minWidth: '100px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '140px', sortable: true},
          {id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right'},
        ],
        opBtnConfig: (row) => [
          {
            label: '编辑',
            show: () => this.$permission('warehouse:edit')
              && row.type === WarehouseEum.type.SELF,
            click: () => this.edit(row),
          },
          {
            label: '启用',
            show: () => this.$permission('warehouse:edit')
              && row.state === WarehouseEum.state.Inactive,
            click: () => this.active([row]),
          },
          {
            label: '停用',
            show: () => this.$permission('warehouse:edit')
              && row.state === WarehouseEum.state.Active,
            click: () => this.inactive([row]),
          },
          {
            label: '删除',
            show: () => this.$permission('warehouse:delete')
              && row.type === WarehouseEum.type.SELF,
            click: () => this.deleteItem([row]),
          },
        ],
        logId: 1,
        WarehouseEum: WarehouseEum,
        filter: {
          warehouseIds: [],
          state: null,
          type: null,
          country: null,
          date: null,
        },
        notStorage: true,
        hideNowStep: false,
        isFinishAddWarehose: false
      }
    },
    computed: {
      selection() {
        return this.tableData.some(item => item.type === WarehouseEum.type.SELF);
      }
    },
    methods: {
      $gjCacheCallback(params) {
        return {
          warehouseIds: params.warehouseIds
        };
      },
      $gjQueryInitParams() {
        return {
          filter: {
            warehouseIds: [],
            type: null,
            state: null,
            country: null,
            date: null,
          }
        }
      },
      $gjQuery() {
        this.loading = true;
        const params = {
          model: {
            state: defaultVal(this.filter.state, null),
            type: defaultVal(this.filter.type, null),
            countryCode: defaultVal(this.filter.country, null),
            warehouseIds: isMeaningless(this.filter.warehouseIds) ? [] : this.filter.warehouseIds,
          },
          ...this.queryPagination,
          ...this.querySort,
        };
        if (isMeaningful(this.filter.date)) {
          params.model.startCreateTime = convertToDate(this.filter.date[0]);
          params.model.endCreateTime = convertToDate(this.filter.date[1]);
        }
        this.globalParams = params;
        getWarehouseInfoPage(params)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      },
      edit(row) {
        this.$gjCreate(AppOpWarehouseModal, {
          props: {
            warehouse: row,
            opType: OpEnum.type.UPDATE
          },
          on: {
            updated: () => {
              this.refreshStoreWarehouse();
              this.$gjResetPage();
            }
          }
        });
      },
      add() {
        this.hideNowStep = true;
        this.$gjCreate(AppOpWarehouseModal, {
          props: {
            opType: OpEnum.type.ADD
          },
          on: {
            created: () => {
              this.refreshStoreWarehouse();
              this.$gjResetPage();
            },
            userGuide: () => {
              this.hideNowStep = false;
              this.isFinishAddWarehose = true;
              // 引导用户
              this.userGuideNextStep()
            },
            close: () => {
              // 关闭引导用户
              if (!this.isFinishAddWarehose){
                this.userGuideCancel()
              }
              this.isFinishAddWarehose = false;
              this.hideNowStep = false
            },
          }
        });
      },
      deleteItem(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: rows.length === 1
              ? `确定要删除仓库[${rows[0].name}]吗？一旦删除不可恢复，请谨慎操作！`
              : `已选中 ${rows.length} 个仓库，确定要批量删除吗？一旦删除不可恢复，请谨慎操作！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteWarehouse({
                ids: rows.map(e => e.id)
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                    this.refreshStoreWarehouse(true, false);
                  });
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      inactive(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '停用确认',
            content: rows.length === 1 ? `确定要停用仓库[${rows[0].name}]吗？` : `已选中 ${rows.length} 个仓库，确定要批量停用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateWarehouseStatus({
                id: rows[0].id,
                status: WarehouseEum.state.Inactive
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                    this.refreshStoreWarehouse();
                  })
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      active(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            content: rows.length === 1 ? `确定要启用仓库[${rows[0].name}]吗？` : `已选中 ${rows.length} 个仓库，确定要批量启用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              updateWarehouseStatus({
                id: rows[0].id,
                status: WarehouseEum.state.Active
              })
                .then(res => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                    this.refreshStoreWarehouse();
                  })
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      refreshStoreWarehouse(self = true, fba = true) {
        this.$store.dispatch(WAREHOUSE_GET_ACTIVE_WAREHOUSE_TREE);
        this.$store.dispatch(WAREHOUSE_GET_WAREHOUSE_TREE);
        if (self) {
          this.$store.dispatch(WAREHOUSE_GET_ACTIVE_SELF_WAREHOUSE_TREE);
          this.$store.dispatch(WAREHOUSE_GET_SELF_WAREHOUSE_TREE);
        }
        if (fba) {
          this.$store.dispatch(WAREHOUSE_GET_ACTIVE_FBA_WAREHOUSE_TREE);
          this.$store.dispatch(WAREHOUSE_GET_FBA_WAREHOUSE_TREE);
        }
      },
      viewLog() {
        this.$gjCreate(GjLogModal, {
          props: {
            url: '/supply/warehouse/logPage',
            params: {
              model: {}
            },
            opTypeOption: [
              {id: 'Add', text: '新增'},
              {id: 'Enable', text: '启用'},
              {id: 'Disable', text: '停用'},
              {id: 'Update', text: '更新'},
              {id: 'Delete', text: '删除'},
            ],
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
